// pages/users/SubDistributorsPage.jsx
import UserRolePage from './UserRolePage.jsx';
export default function SubDistributorsPage() {
  return <UserRolePage role="subdistributor" title="Sub Distributors" accentColor="#d97706"
    roleOptions={['subdistributor']} />;
}